import styled from 'styled-components';

import bg from '../../assets/Bg.png';

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-around;
  flex-direction: row;
  min-height: 100vh;
  background-image: url(${bg});
  background-repeat: no-repeat;
  background-size: 100% 100%;
`;
